<template>
    <div class="payment-estimator">
        <div class="payment-estimator_results vcore_row vcore_no-gutters">
        <div class="payment-estimator_result vcore_col--md--6 vcore_col--lg--3">
            <div class="payment-estimator_result_label">Total Loan Amount</div>
            <div
            v-if="displayLoanInfo && totalLoanAmount !== undefined"
            id="payment-estimator_result_total-loan-amount"
            class="payment-estimator_result_value"
            >
            {{ totalLoanAmount | toUSD }}
            </div>
            <div v-else class="payment-estimator_result_value">
            —
            </div>
        </div>
        <div class="payment-estimator_result vcore_col--md--6 vcore_col--lg--3">
            <div class="payment-estimator_result_label">Est. Monthly Payment**</div>
            <div
            v-if="displayLoanInfo && estimatedMonthlyPayment !== undefined"
            id="payment-estimator_result_est-monthly-payment"
            class="payment-estimator_result_value"
            >
            {{ estimatedMonthlyPayment | toUSD }}
            </div>
            <div v-else class="payment-estimator_result_value">
            —
            </div>
        </div>
        <div class="payment-estimator_result vcore_col--md--6 vcore_col--lg--3">
            <div class="payment-estimator_result_label">Term</div>
            <div
            v-if="displayLoanInfo && loanTermInMonths !== undefined && totalLoanAmount !== 0"
            id="payment-estimator_result_loan-term"
            class="payment-estimator_result_value"
            >
            {{ loanTermInMonths }} mo.
            </div>
            <div v-else class="payment-estimator_result_value">
            —
            </div>
        </div>
        <div class="payment-estimator_result vcore_col--md--6 vcore_col--lg--3">
            <div class="payment-estimator_result_label">
            APR
            <span v-if="aprAsterisk === 1"></span>
            <span v-else-if="aprAsterisk === 2">*</span>
            </div>
            <div
                v-if="displayLoanInfo && loanRateDisplay !== undefined"
                id="payment-estimator_result_loan-rate"
                class="payment-estimator_result_value"
            >
                <div v-if="isFixedRate">{{ loanRateDisplay.toFixed(2) }}%</div>
                <div v-else>{{ loanRateDisplay.toFixed(2) }}% Variable</div>
            </div>
            <div v-else class="payment-estimator_result_value">
            —
            </div>
        </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "LoanInfo",
        props: {
            displayLoanInfo: {
                type: Boolean,
                default: true
            },
            totalLoanAmount: {
                type: Number
            },
            estimatedMonthlyPayment: {
                type: Number
            },
            loanTermInMonths: {
                type: Number
            },
            aprAsterisk: {
                type: Number,
                default: 0
            },
            isFixedRate: {
                type: Boolean,
                default: true
            },
            loanRateDisplay: {
                type: Number
            },
        },
        data() {
            return {
            
            }
        },
        computed: {
            
        },
        methods: {
            
        }
    };
</script>
<style lang="scss" scoped>
.payment-estimator {
    background-color: $color_its-not-white;

  .payment-estimator_results {
    border: 1px solid #d3d6de;
    padding: 25px 0 5px;
    height: 100%;
    margin-top: 24px;

    .payment-estimator_result {
      text-align: center;
      margin-bottom: 20px;

      .payment-estimator_result_label {
        font-size: 14px;
        font-weight: bold;
        white-space: nowrap;

        @media (max-width: $grid-breakpoint-sm) {
          white-space: normal;
        }
      }

      .payment-estimator_result_value {
        font-family: Poppins;
        font-size: 22px;
        font-weight: 600;
        color: $color_dark-blue;
        margin-top: 10px;

        @media (max-width: $grid-breakpoint-sm) {
          font-size: 18px;
        }
      }
    }
  }
}
</style>